export default "__VITE_ASSET__f0317cf1__"